module.exports = __webpack_public_path__ + "static/media/46.3811bd6e.png";